<template lang="pug">
div.mb-30
  div.header
    span.task.text-20-b Активные задания
    span.all.text-16-b( @click="openAllTask" ) Все
  scroll-list-of-tasks( :listBlocks="taskList" )
</template>
<script>
import { mapActions, mapState } from 'vuex';
import ScrollListOfTasks from './ScrollListOfTasks.vue';
export default {
  name: 'GoalPanel',

  components: {
    ScrollListOfTasks
  },

  mounted() {
    if(!this.taskList) this.loadTaskList()
  },

  computed: {
    ...mapState('tasks', ['taskList', 'testTask']),
  },

  methods: {
    ...mapActions('tasks', ['loadTaskList', 'getFormTask', 'createTestTask']),

    openAllTask() {
      this.$router.push({path:"/allTasks"})
    }
  }
}

</script>
<style scoped>
.mb-30 {
  margin-bottom: 60px;
}
.task {
  width: 100%;
  padding-left: 20px;
}
.header {
  display: flex;
  align-items: center;
}
.all {
  margin-left: auto;
  margin-right: 40px;
  color:#5365E5;
}
</style>
